import Substore from "../Substore";

export default class ChangelogModalStore extends Substore {
  shown = false;
}
